import React, { Component } from "react";
import Wrp from '../../../../../../../hoc/Wrp/Wrp';
// import {Card,CardBody} from '../../../../../../../hoc/Card';
// import BootstrapRow from '../../../../../../../hoc/BootstrapRow';
// import BootstrapColumn from '../../../../../../../hoc/BootstrapColumn';
import Datetime from 'react-datetime';
import moment from 'moment';
import 'react-datetime/css/react-datetime.css';
import {getDateFormat} from '../../../../../../../Utils/UserFunctions';
import {WeeksSequenceList,MonthsList,WeeksList,MonthDaysList} from '../defaultList';
class RepeatEveryYears extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dt: moment(),
      setDt: moment(),
      isReminderPopup:false,
      isReminderSelected:false
    }
  }
  render() {
    const  {
      reminderJson,
      actionChangeHandler,
    } = this.props;

    
    return (
      <Wrp>
    {(reminderJson.repeatOption==='DAY')?
        <div className="d-flex w-100 mb-3">
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text">on</span>
            </div>
            <input type="number" max={31} min={1} className="form-control" 
                onChange={e=>actionChangeHandler(e,'repeat_dom',e.target.value)}/>
          </div>
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text">day of</span>
            </div>
            <select className="form-control" value={reminderJson.repeat_month} onChange={e=>actionChangeHandler(e,'repeat_month',e.target.value)}>
                <FillOptionsList 
                    list={MonthsList()}
                    selectedValue={''} />
                
            </select>
          </div>
        </div>
       : 
        <div className="d-flex w-100 mb-3">
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text"> on</span>
            </div>
            <select className="form-control" value={reminderJson.repeat_weekseq} onChange={e=>actionChangeHandler(e,'repeat_weekseq',e.target.value)}>
                <FillOptionsList 
                    list={WeeksSequenceList()}
                    selectedValue={''} />
            </select>
            <select className="form-control" value={reminderJson.repeat_weekday} onChange={e=>actionChangeHandler(e,'repeat_weekday',e.target.value)}>
                <FillOptionsList 
                    list={WeeksList()}
                    selectedValue={''} />
            </select>
          </div>
          
          <div className="input-group" style={{width:'50%'}}>
            <div className="input-group-prepend">
              <span className="input-group-text"> of</span>
            </div>
            <select className="form-control" value={reminderJson.repeat_month} onChange={e=>actionChangeHandler(e,'repeat_month',e.target.value)}>
                <FillOptionsList 
                    list={MonthsList()}
                    selectedValue={''} />
            </select>
          </div>
        </div>
        }
      </Wrp>    
    );
  } 
}


const FillOptionsList = (props)=>{
    const {list,selectedValue}= props;
    return list.map((item,itemIndex)=>{
        return(
            <option key={itemIndex} value={item.value}>{item.label}</option>
        )
    })
}
export default RepeatEveryYears;
